export const ZEALOT_AUTH_MESSAGES = {
  AUTH_REQUIRED: 'zealot:auth_required',
  AUTH_TOKEN: 'zealot:auth_token',
  AUTH_CANCEL: 'zealot:auth_cancel',
} as const;

export const AUTH_STRATEGY_NOT_READY_MESSAGE = 'Auth strategy not ready: brand not loaded yet';
